module.exports = __webpack_public_path__ + "media/images/icons/since-badge-white-de-7cd2c582452a280e06a7ce19d989584c.svg";